// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/campaign_stats/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignStatsCampaignId } from "./constants";
import type { EngagementCampaignStats } from "./types";

export const getEngagementCampaignStats = reactQueryFetcherAdapter(
  engagementCampaignStatsCampaignId,
  (
    signal: AbortSignal,
    campaignId: string,
    appGroupId: string,
    start: number,
    end: number,
    useSpecificTimeWindow?: boolean,
    setAbStats?: boolean
  ): Promise<EngagementCampaignStats> => {
    return fetch(
      `/engagement/campaign_stats/${campaignId}`,
      "GET",
      {
        app_group_id: appGroupId,
        start: start,
        end: end,
        use_specific_time_window: useSpecificTimeWindow,
        set_ab_stats: setAbStats,
      },
      { signal }
    );
  }
);
